import { DSR_API_METHOD_TYPES } from '@sdk/api/modules/dsr/types.dsr'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Signal to DSR that the app is ready to be shown.
 *
 * @example
 * useDsr().embeddableReady()
 */
export async function embeddableReady(): Promise<void> {
  const pr = await usePostRobot()
  await pr.send(window.parent, DSR_API_METHOD_TYPES.DSR_EMBEDDABLE_READY)
}
